import React from 'react';
import { theme } from '../../utils/theme';

const UserManagement = ({ users, currentPage, onPageChange }) => {
    const tableStyles = {
        wrapper: `${theme.card.base} bg-opacity-5 overflow-hidden`,
        table: "min-w-full",
        header: "border-b border-[#6D9773]/20",
        headerCell: "px-6 py-3 text-left text-xs font-medium text-[#0C3B2E] uppercase tracking-wider",
        row: "border-b border-[#6D9773]/10 hover:bg-[#6D9773]/5 transition-colors",
        cell: "px-6 py-4 text-sm text-[#0C3B2E]"
    };

    const renderPagination = () => {
        const totalPages = Math.ceil(users.total / 10);
        let startPage = Math.max(1, currentPage - 5);
        let endPage = Math.min(totalPages, currentPage + 5);

        if (startPage === 1) {
            endPage = Math.min(11, totalPages);
        }
        if (endPage === totalPages) {
            startPage = Math.max(1, totalPages - 10);
        }

        const pages = [];
        
        if (startPage > 1) {
            pages.push(1);
            if (startPage > 2) pages.push('...');
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        if (endPage < totalPages) {
            if (endPage < totalPages - 1) pages.push('...');
            pages.push(totalPages);
        }

        return (
            <div className="flex justify-center gap-2 mt-4">
                {currentPage > 1 && (
                    <button
                        onClick={() => onPageChange(currentPage - 1)}
                        className={`${theme.button.base} ${theme.button.secondary} ${theme.button.sizes.sm}`}
                    >
                        Previous
                    </button>
                )}
                
                {pages.map((page, index) => (
                    page === '...' ? (
                        <span key={`ellipsis-${index}`} className="px-3 py-2">...</span>
                    ) : (
                        <button
                            key={page}
                            onClick={() => onPageChange(page)}
                            className={`${theme.button.base} ${
                                currentPage === page ? theme.button.primary : theme.button.secondary
                            } ${theme.button.sizes.sm}`}
                        >
                            {page}
                        </button>
                    )
                ))}

                {currentPage < totalPages && (
                    <button
                        onClick={() => onPageChange(currentPage + 1)}
                        className={`${theme.button.base} ${theme.button.secondary} ${theme.button.sizes.sm}`}
                    >
                        Next
                    </button>
                )}
            </div>
        );
    };

    return (
        <div className={tableStyles.wrapper}>
            <div className="overflow-x-auto">
                <table className={tableStyles.table}>
                    <thead className={tableStyles.header}>
                        <tr>
                            <th className={tableStyles.headerCell}>Name</th>
                            <th className={tableStyles.headerCell}>Email</th>
                            <th className={tableStyles.headerCell}>Joined</th>
                            <th className={tableStyles.headerCell}>Last Login</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.data.map(user => (
                            <tr key={user.id} className={tableStyles.row}>
                                <td className={tableStyles.cell}>{user.name}</td>
                                <td className={tableStyles.cell}>{user.email}</td>
                                <td className={tableStyles.cell}>{new Date(user.createdAt).toLocaleDateString()}</td>
                                <td className={tableStyles.cell}>
                                    {user.lastLogin ? new Date(user.lastLogin).toLocaleString() : 'Never'}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {renderPagination()}
        </div>
    );
};

export default UserManagement;